var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmptyLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 200,
    viewBox: "0 0 400 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_43829_46907)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M270.811 148.742C270.235 149.552 269.474 150.212 268.593 150.67C267.711 151.128 266.733 151.369 265.74 151.373H134.262C133.268 151.369 132.29 151.128 131.409 150.67C130.527 150.212 129.767 149.552 129.19 148.742C153.921 93.7034 148.787 105.137 156.175 88.7227H243.827C251.778 106.421 245.893 93.3588 270.811 148.742Z",
    fill: "#A8C5E3"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.174 48V88.7228C148.223 106.422 154.108 93.3589 129.19 148.742C128.405 147.695 127.987 146.417 128 145.108V101.253L156.174 48Z",
    fill: "#D9E7F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M272 101.253V145.108C272.014 146.417 271.596 147.695 270.81 148.742C246.08 93.7035 251.214 105.137 243.826 88.7228V48L272 101.253Z",
    fill: "#D9E7F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M272 101.879V145.734C272 147.396 271.34 148.99 270.166 150.164C268.992 151.339 267.399 151.999 265.739 151.999H134.261C132.6 151.999 131.008 151.339 129.834 150.164C128.66 148.99 128 147.396 128 145.734V101.879H181.499C182.254 101.871 182.987 102.135 183.562 102.625C184.137 103.114 184.516 103.795 184.629 104.542C185.112 107.376 186.365 110.022 188.251 112.191C190.137 114.36 192.583 115.968 195.321 116.838C198.06 117.709 200.984 117.808 203.775 117.125C206.566 116.443 209.116 115.004 211.144 112.968C213.42 110.67 214.938 107.729 215.495 104.542C215.609 103.795 215.988 103.114 216.563 102.625C217.138 102.135 217.871 101.871 218.626 101.879H272Z",
    fill: "#EFF5FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M156.174 48H243.826V88.7228H156.174V48Z",
    fill: "#C0D6EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.165 141.974H144.904C144.074 141.974 143.277 141.644 142.69 141.057C142.103 140.469 141.773 139.672 141.773 138.842C141.773 138.011 142.103 137.214 142.69 136.626C143.277 136.039 144.074 135.709 144.904 135.709H151.165C151.995 135.709 152.791 136.039 153.378 136.626C153.965 137.214 154.295 138.011 154.295 138.842C154.295 139.672 153.965 140.469 153.378 141.057C152.791 141.644 151.995 141.974 151.165 141.974Z",
    fill: "#96B9DE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M157.426 129.445H144.904C144.074 129.445 143.277 129.115 142.69 128.527C142.103 127.94 141.773 127.143 141.773 126.312C141.773 125.481 142.103 124.685 142.69 124.097C143.277 123.51 144.074 123.18 144.904 123.18H157.426C158.256 123.18 159.052 123.51 159.639 124.097C160.226 124.685 160.556 125.481 160.556 126.312C160.556 127.143 160.226 127.94 159.639 128.527C159.052 129.115 158.256 129.445 157.426 129.445Z",
    fill: "#96B9DE"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_43829_46907",
    x: 129.19,
    y: 88.7227,
    width: 141.62,
    height: 62.6504,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.619653 0 0 0 0 0.746598 0 0 0 0 0.880797 0 0 0 0.74 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_43829_46907"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyLarge);
export default __webpack_public_path__ + "static/media/EmptyLarge.05f82e33b890dff9c7ae81ab340a5e24.svg";
export { ForwardRef as ReactComponent };